module.exports = {
  title: '领克|领克汽车|Lynk&Co',
  baseUrl: 'https://usedcar-uat.lynkco.com/service',
  baseApi: 'https://usedcar-uat.lynkco.com/service',
  // baseUrl: 'https://usedcar.lynkco.com/service', // 正式项目地址
  // baseApi: 'https://usedcar.lynkco.com/service', // 正式api请求地址
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: '',
  gaode_key: '42c429b67bff8d888951c99c93fcfe37',
  mapDomain: 'https://usedcar-uat.lynkco.com/_AMapService',
  replaceClueOrigin: '97809fefce734c28'
};